import { PlayerBalance } from '@app/models/player-balance';
import { createAction, props } from '@ngrx/store';

export const upsertOne = createAction('[Player Balance] Upsert Player Balance', props<{ playerBalance: PlayerBalance }>());
